module.exports = __webpack_public_path__ + "img/locus-logo2.2aca36b0.png";